import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

import css from './FaqPage.module.css';
import image from './about-us-1056.jpg';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const FaqPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);


  const classes = useStyles();

  // prettier-ignore
  return (
    <StaticPage
      title="FAQ for students"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'FAQ fo students',
        name: 'FAQ fo students',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>FAQ for students</h1>

          <div className={css.contentWrapper}>
          
            <div className={css.contentMain}>


            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}><h2 className={css.questionStyle}>
                       How do you verify AppBuddy Helpers?
                          </h2></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                <h2 className={css.questionStyle}>
                    The AppBuddy team takes time to screen every AppBuddy Helper. We verify all credentials. It is a tedious yet crucial process. We continuously ensure that you are receiving high quality services from our AppBuddy Helpers. We also rely on your feedback from your experience with our AppBuddy Helpers!    
                  </h2>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}><h2 className={css.questionStyle}>
                      Do you have AppBuddy Helpers in Canada?
                          </h2></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                <h2 className={css.questionStyle}>
                  Yes, we love our neighbors up North! AppBuddy Helpers are located across North America. What are you waiting for, eh?    
                  </h2>
                </Typography>
              </AccordionDetails>
            </Accordion>


            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}><h2 className={css.questionStyle}>
                      Who sets the price?  
                          </h2></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                <h2 className={css.questionStyle}>
                  The AppBuddy team does not set the prices - we are simply here to connect you to an AppBuddy Helper. We believe you shouldn't be paying thousands of dollars for application help - prices need to be affordable and accessible.    
                  </h2>
                  <h2 className={css.questionStyle}> Each AppBuddy Helper sets their own prices for the services they are offering. We ensure that you can always find someone that works within your budget!</h2>
                </Typography>
              </AccordionDetails>
            </Accordion>


            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}><h2 className={css.questionStyle}>
                    I have additional questions. Who should I contact?  
                          </h2></Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                <h2 className={css.questionStyle}>
                   We'd love to answer your questions! Email us at info@theappbuddy.com      
                  </h2>
                </Typography>
              </AccordionDetails>
            </Accordion>

            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FaqPage;
